<template>
  <el-card class="contract-item" shadow="never">
    <div class="contract-header" @click="toggleCollapse">
      <span class="contract-title">
        合同有效期：{{ contract.contractOn }} ~ {{ contract.contractOff }}
        <span v-if="isCurrentValid" class="status active"> 有效 </span>
      </span>
      <el-button type="warning" plain size="small" @click.stop="openConfirmDialog">关键信息确认</el-button>
      <el-button v-if="mode === 'view'" type="default" plain size="small" @click.stop="edit">编辑</el-button>
      <el-button v-if="mode === 'edit'" type="primary" size="small" @click.stop="save">保存</el-button>
      <el-button v-if="mode === 'edit'" type="default" plain size="small" @click.stop="cancel">取消</el-button>
      <el-button v-if="mode === 'edit' && !contract.id" type="default" plain size="small"
        @click.stop="deleteItem">删除</el-button>
      <span class="arrow-icon" :class="{ rotated: expanded }">&#9660;</span>
    </div>
    <el-collapse-transition>
      <div v-show="expanded" class="contract-body">
        <el-form ref="formRef" :model="formData" :rules="rules" label-width="140px" :disabled="mode === 'view'"
          size="small" class="contract-form">
          <div class="form-section">
            <div class="form-section-title">基本信息</div>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="签订日期" prop="signDate">
                  <el-date-picker v-model="formData.signDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                    style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="有效期起" prop="contractOn">
                  <el-date-picker v-model="formData.contractOn" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"
                    style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="有效期止" prop="contractOff">
                  <el-date-picker v-model="formData.contractOff" type="date" value-format="yyyy-MM-dd"
                    placeholder="结束日期" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="首次签约" prop="firstContract">
                  <div class="switch-wrap">
                    <el-switch v-model="formData.firstContract" @change="onFirstContractChange" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="押金" prop="deposit">
                  <el-input-number v-model="formData.deposit" :min="0" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="保底积分" prop="basePoints">
                  <el-input-number v-model="formData.basePoints" :min="0" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="每月休息" prop="maxLeaveDaysPerMonth">
                  <el-input-number v-model="formData.maxLeaveDaysPerMonth" :min="0" :max="31" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="保底收入" prop="baseSalary">
                  <el-input-number v-model="formData.baseSalary" :min="0" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div v-if="formData.firstContract" class="form-section form-section--highlight">
            <div class="form-section-title">首次签约信息</div>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="磨合期收入" prop="probationarySalary">
                  <el-input-number v-model="formData.probationarySalary" :min="0" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="磨合期开始" prop="probationaryStart">
                  <el-date-picker v-model="formData.probationaryStart" type="date" value-format="yyyy-MM-dd"
                    placeholder="开始日期" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="磨合期结束" prop="probationaryEnd">
                  <el-date-picker v-model="formData.probationaryEnd" type="date" value-format="yyyy-MM-dd"
                    placeholder="结束日期" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="押金借款" prop="depositLoan">
                  <el-input-number v-model="formData.depositLoan" :min="0" style="width: 100%" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="累计还款" prop="totalRepaidLoan">
                  <el-input-number v-model="formData.totalRepaidLoan" :min="0" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="form-section">
            <div class="form-section-title">合同附件</div>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="合作协议" prop="pdfOfContact">
                  <file-upload uploadType="choose" v-model="formData.pdfOfContact" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="租赁合同" prop="pdfOfLeaseContact">
                  <file-upload uploadType="choose" v-model="formData.pdfOfLeaseContact" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="补充协议" prop="pdfOfAdditionalAgreement">
                  <file-upload uploadType="choose" v-model="formData.pdfOfAdditionalAgreement" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="押金借条" prop="pdfOfLoanNote">
                  <file-upload uploadType="choose" v-model="formData.pdfOfLoanNote" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="委托付款承诺书" prop="pdfOfCommitmentOfPayment">
                  <file-upload uploadType="choose" v-model="formData.pdfOfCommitmentOfPayment" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="从业资格证承诺书" prop="pdfOfCommitmentOfQualifications">
                  <file-upload uploadType="choose" v-model="formData.pdfOfCommitmentOfQualifications" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="车辆风险告知书" prop="pdfOfRiskNotificationOfVehicle">
                  <file-upload uploadType="choose" v-model="formData.pdfOfRiskNotificationOfVehicle" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签约风险告知书" prop="pdfOfRiskNotificationOfContract">
                  <file-upload uploadType="choose" v-model="formData.pdfOfRiskNotificationOfContract" :filePath="$ossPath.driverContract(driver && driver.id)" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>

        <div class="indicator-section">
          <div class="indicator-header">
            <span>司机指标管理</span>
            <div v-if="mode === 'edit'">
              <el-button type="primary" size="mini" @click.stop="addIndicator">新增指标</el-button>
              <el-button size="mini" @click.stop="quickCreate">快捷创建</el-button>
            </div>
          </div>
          <el-table :data="formData.indicators" stripe max-height="400">
            <el-table-column label="序号" type="index" width="60" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pathId" label="路线" width="200">
              <template slot-scope="scope">
                <el-select v-model="scope.row.pathId" size="small" placeholder="请选择路线" :disabled="mode === 'view'">
                  <el-option v-for="item in pathOpts" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="routePoints" label="行程积分" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.routePoints" size="small" placeholder="请输入行程积分"
                  :disabled="mode === 'view'"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="powerFee" label="单边电费" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.powerFee" size="small" placeholder="请输入单边电费(元)"
                  :disabled="mode === 'view'"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button v-if="mode === 'edit'" type="text" size="small"
                  @click.stop="deleteIndicator(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-collapse-transition>

    <el-dialog :visible.sync="confirmVisible" width="640px" append-to-body custom-class="driver-confirm-dialog"
      :show-close="true" @click.native.stop>
      <table class="confirm-table" v-if="confirmVisible">
        <thead>
          <tr>
            <th colspan="3">司机签约信息确认表</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="section-cell" :rowspan="4">司机基础信息</td>
            <td class="label-cell">姓名</td>
            <td class="value-cell">{{ driver?.name || "-" }}</td>
          </tr>
          <tr>
            <td class="label-cell">司机编号</td>
            <td class="value-cell">{{ driver?.no || "-" }}</td>
          </tr>
          <tr>
            <td class="label-cell">押金</td>
            <td class="value-cell">{{ displayVal(formData.deposit) }}</td>
          </tr>
          <tr>
            <td class="label-cell">借款</td>
            <td class="value-cell">{{ displayVal(formData.depositLoan) }}</td>
          </tr>

          <tr>
            <td class="section-cell" :rowspan="9">提车签约核心信息</td>
            <td class="label-cell">签约日期</td>
            <td class="value-cell">{{ formatDotDate(formData.signDate) }}</td>
          </tr>
          <tr>
            <td class="label-cell">司机磨合期（3个月）</td>
            <td class="value-cell">{{ probationPeriodText }}</td>
          </tr>
          <tr>
            <td class="label-cell">所提车辆车牌号</td>
            <td class="value-cell">{{ driver?.vehicleNo || "-" }}</td>
          </tr>
          <tr>
            <td class="label-cell">提车表显里程</td>
            <td class="value-cell">-</td>
          </tr>
          <tr>
            <td class="label-cell">合约期限</td>
            <td class="value-cell">{{ contractDurationText }}</td>
          </tr>
          <tr>
            <td class="label-cell">初始积分</td>
            <td class="value-cell">{{ formatRoutePoints(formData.basePoints) }}</td>
          </tr>
          <tr>
            <td class="label-cell">基本收入</td>
            <td class="value-cell">{{ baseIncomeText }}</td>
          </tr>
          <tr>
            <td class="label-cell">保底收入</td>
            <td class="value-cell">{{ formData.baseSalary != null ? formData.baseSalary + "元" : "-" }}</td>
          </tr>
          <tr>
            <td class="label-cell">休息天数</td>
            <td class="value-cell">{{ formData.maxLeaveDaysPerMonth != null ? formData.maxLeaveDaysPerMonth + "天" : "-"
            }}
            </td>
          </tr>

          <tr v-for="(item, idx) in indicatorList" :key="'point-' + idx">
            <td v-if="idx === 0" class="section-cell" :rowspan="indicatorList.length || 1">出车积分（单程）</td>
            <td class="label-cell">{{ getPathName(item.pathId) }}</td>
            <td class="value-cell">{{ formatRoutePoints(item.routePoints) }}</td>
          </tr>
          <tr v-if="!indicatorList.length">
            <td class="section-cell">出车积分（单程）</td>
            <td class="label-cell" colspan="2">暂无指标</td>
          </tr>

          <tr v-for="(item, idx) in indicatorList" :key="'fee-' + idx">
            <td v-if="idx === 0" class="section-cell" :rowspan="indicatorList.length || 1">电费补贴标准（单程）</td>
            <td class="label-cell">{{ getPathName(item.pathId) }}</td>
            <td class="value-cell">{{ item.powerFee != null && item.powerFee !== "" ? item.powerFee + "元" : "-" }}</td>
          </tr>
          <tr v-if="!indicatorList.length">
            <td class="section-cell">电费补贴标准（单程）</td>
            <td class="label-cell" colspan="2">暂无指标</td>
          </tr>
        </tbody>
      </table>
      <span slot="footer">
        <el-button size="small" @click="confirmVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { saveOrUpdateContract } from "@/api";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "DriverContractItem",
  props: {
    contract: {
      type: Object,
      required: true
    },
    driver: {
      type: Object,
      default: null
    },
    allContracts: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: "view" // view/edit
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      pathOpts: (state) => state.pathList
    }),
    isCurrentValid() {
      const { contractOn, contractOff } = this.contract || {};
      if (contractOn && contractOff) {
        const now = moment();
        return (
          moment(contractOn).subtract(1, "day").isBefore(now) &&
          moment(contractOff).add(1, "day").isAfter(now)
        );
      }
      return false;
    },
    indicatorList() {
      return (this.formData.indicators || []).filter((item) => item && item.pathId);
    },
    probationPeriodText() {
      const { probationaryStart, probationaryEnd } = this.formData;
      if (!probationaryStart && !probationaryEnd) {
        return "-";
      }
      return `${this.formatShortDotDate(probationaryStart)}-${this.formatShortDotDate(probationaryEnd)}`;
    },
    contractDurationText() {
      const { contractOn, contractOff } = this.formData;
      if (!contractOn || !contractOff) {
        return "-";
      }
      const months = moment(contractOff).add(1, "day").diff(moment(contractOn), "months");
      const dateRange = `${this.formatDotDate(contractOn)}-${this.formatDotDate(contractOff)}`;
      return months > 0 ? `${months}个月（${dateRange}）` : dateRange;
    },
    baseIncomeText() {
      const { firstContract, probationarySalary } = this.formData;
      if (firstContract && probationarySalary != null) {
        return `前3个月${probationarySalary}元`;
      }
      return "-";
    }
  },
  data() {
    return {
      confirmVisible: false,
      formData: { ...this.contract, indicators: this.cloneIndicators(this.contract.indicators) },
      rules: {
        signDate: [{ required: true, message: "请选择合同签订日期", trigger: "change" }],

        contractOn: [{ required: true, message: "请选择合同开始日期", trigger: "change" }],
        contractOff: [{ required: true, message: "请选择合同结束日期", trigger: "change" }],
        deposit: [{ required: true, message: "请输入押金", trigger: "blur" }],
        basePoints: [{ required: true, message: "请输入保底积分", trigger: "blur" }],
        maxLeaveDaysPerMonth: [
          { required: true, message: "请输入每月最大休息天数", trigger: "blur" }
        ],
        baseSalary: [{ required: true, message: "请输入保底收入", trigger: "blur" }]
      }
    };
  },
  watch: {
    contract: {
      handler(val) {
        this.formData = { ...val, indicators: this.cloneIndicators(val.indicators) };
      },
      deep: true
    },
    mode(val) {
      if (val === "edit") {
        this.formData = {
          ...this.contract,
          indicators: this.cloneIndicators(this.contract.indicators)
        };
      }
    }
  },
  methods: {
    toggleCollapse() {
      this.$emit("toggleCollapse");
    },

    openConfirmDialog() {
      this.confirmVisible = true;
    },

    displayVal(val) {
      return val != null && val !== "" ? val : "-";
    },

    formatDotDate(date) {
      if (!date) {
        return "-";
      }
      const m = moment(date);
      if (!m.isValid()) {
        return "-";
      }
      return `${m.year()}.${m.month() + 1}.${m.date()}`;
    },

    formatShortDotDate(date) {
      if (!date) {
        return "";
      }
      const m = moment(date);
      if (!m.isValid()) {
        return "";
      }
      return `${m.month() + 1}.${m.date()}`;
    },

    getPathName(pathId) {
      const path = (this.pathOpts || []).find((item) => item.id === pathId);
      return path ? path.name : "-";
    },

    formatRoutePoints(points) {
      if (points == null || points === "") {
        return "-";
      }
      const num = Number(points);
      if (Number.isNaN(num)) {
        return "-";
      }
      return `${(num / 100).toFixed(1)}分`;
    },

    onFirstContractChange(val) {
      if (!val) {
        this.clearFirstContractFields();
      }
    },

    clearFirstContractFields() {
      this.formData.probationarySalary = null;
      this.formData.probationaryStart = null;
      this.formData.probationaryEnd = null;
      this.formData.depositLoan = null;
      this.formData.totalRepaidLoan = null;
    },

    overlapsOtherFirstContract() {
      if (!this.formData.firstContract) {
        return false;
      }
      const { contractOn, contractOff } = this.formData;
      if (!contractOn || !contractOff) {
        return false;
      }
      const start = moment(contractOn);
      const end = moment(contractOff);
      return (this.allContracts || []).some((item) => {
        if (item === this.contract || (this.formData.id && item.id === this.formData.id)) {
          return false;
        }
        if (!item.firstContract || !item.contractOn || !item.contractOff) {
          return false;
        }
        const otherStart = moment(item.contractOn);
        const otherEnd = moment(item.contractOff);
        return !start.isAfter(otherEnd, "day") && !otherStart.isAfter(end, "day");
      });
    },

    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.validateIndicators()) {
            return;
          }
          if (this.overlapsOtherFirstContract()) {
            this.$message.error("首次签约合同的有效期不能重叠");
            return;
          }
          const payload = { ...this.formData };
          if (!payload.firstContract) {
            payload.firstContract = false;
            payload.probationarySalary = null;
            payload.probationaryStart = null;
            payload.probationaryEnd = null;
            payload.depositLoan = null;
            payload.totalRepaidLoan = null;
          }
          saveOrUpdateContract(payload).then((res) => {
            this.$emit("save", res.data);
            this.$message.success("保存成功");
          });
        }
      });
    },

    cancel() {
      this.$emit("cancel");
    },
    edit() {
      this.$emit("edit");
    },
    deleteItem() {
      if (this.contract.id) {
        this.$message.warning("已创建的合同无法删除");
      } else {
        this.$emit("delete");
      }
    },
    addIndicator() {
      if (!Array.isArray(this.formData.indicators)) {
        this.$set(this.formData, "indicators", []);
      }
      this.formData.indicators.push({
        pathId: null,
        routePoints: null,
        powerFee: null
      });
    },
    quickCreate() {
      const presets = [
        { pathId: 6, routePoints: 90, powerFee: 45 },
        { pathId: 7, routePoints: 90, powerFee: 45 },
        { pathId: 17, routePoints: 50, powerFee: 23 },
        { pathId: 18, routePoints: 50, powerFee: 23 }
      ];
      this.$set(
        this.formData,
        "indicators",
        presets.map((item) => ({ ...item }))
      );
    },
    deleteIndicator(index) {
      this.$confirm("确认删除该指标吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.formData.indicators.splice(index, 1);
      });
    },
    validateIndicators() {
      const list = this.formData.indicators || [];
      const hasEmptyPath = list.some((item) => !item.pathId);
      if (hasEmptyPath) {
        this.$message.error("请选择路线");
        return false;
      }
      return true;
    },
    cloneIndicators(list) {
      return Array.isArray(list) ? list.map((item) => ({ ...item })) : [];
    }
  }
};
</script>
<style lang="less" scoped>
.contract-item {
  margin-bottom: 16px;
}

.contract-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;

  .el-button {
    margin-left: 8px;
  }
}

.contract-title {
  flex: 1;
}

.status {
  margin-left: 12px;
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;

  &.active {
    background: #67c23a;
  }

  &.inactive {
    background: #f56c6c;
  }
}

.contract-body {
  margin-top: 16px;
}

.form-section {
  margin-bottom: 16px;
  padding: 12px 16px 4px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;

  &--highlight {
    background: #f5f9ff;
    border-color: #d6e4ff;
  }
}

.form-section-title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
}

.contract-form {
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }

  ::v-deep .el-date-editor.el-input,
  ::v-deep .el-date-editor.el-input__inner {
    width: 100%;
  }

  ::v-deep .el-input-number .el-input__inner {
    text-align: left;
  }
}

.switch-wrap {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.indicator-section {
  margin-top: 8px;
  padding: 12px 16px 16px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.indicator-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.mx-2 {
  margin: 0 8px;
}

.arrow-icon {
  margin-left: 8px;
  font-size: 16px;
  display: inline-block;
  transition: transform 0.2s;

  &.rotated {
    transform: rotate(180deg);
  }
}

.confirm-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 14px;
  color: #303133;

  th,
  td {
    border: 1px solid #303133;
    padding: 10px 12px;
    text-align: center;
    vertical-align: middle;
    word-break: break-all;
  }

  thead th {
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    padding: 12px;
  }

  .section-cell {
    width: 22%;
    font-weight: 600;
    background: #fafafa;
  }

  .label-cell {
    width: 38%;
  }

  .value-cell {
    width: 40%;
  }
}
</style>

<style lang="less">
.driver-confirm-dialog {
  .el-dialog__header {
    padding: 12px 20px 0;
  }

  .el-dialog__body {
    padding: 10px 20px 0;
  }
}
</style>
